import { pinLabelColors, type MapAppearance } from '../lib/mapAppearance'

/** The same label treatment for pin names and committed line names. */
export function MapNameLabel({
  name,
  size,
  appearance,
}: {
  name: string
  size: number
  appearance: MapAppearance
}) {
  const colors = pinLabelColors(appearance.labelBackground)
  return (
    <span
      style={{
        display: 'block',
        fontFamily: 'Geist, ui-sans-serif, system-ui, sans-serif',
        fontSize: size,
        lineHeight: 1.2,
        fontWeight: 600,
        color: colors.text,
        opacity: appearance.labelOpacity / 100,
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        ...(appearance.labelBackground
          ? {
              background: colors.pillFill,
              border: `1px solid ${colors.pillBorder}`,
              borderRadius: 4,
              padding: '1px 5px',
            }
          : {
              textShadow: `0 0 2px ${colors.textHalo}, 0 0 2px ${colors.textHalo}`,
            }),
      }}
    >
      {name}
    </span>
  )
}
